const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان',
    },
    details: {
      type: 'string',
      title: 'توضیحات',

    },
  },
});

export default schema;
